// extracted by mini-css-extract-plugin
export default {"content":"PriMedosmotry_content__mxcGN","title":"PriMedosmotry_title__eNpW5"};